export default "__VITE_ASSET__d0d18a45__"